<template>
  <div>
    <!-- 主页 -->
    <home ref="mychild" v-show="NavBtn === 'home'"></home>
    <!-- 消息页 -->
    <comment v-show="NavBtn === 'comment'"></comment>
    <!-- 个人页 -->
    <custom v-show="NavBtn === 'custom'"></custom>
    <!-- 导航 -->
    <div class="Navigation">
      <div class="Navigation_btn" @click="navBtn('home')">
        <div v-if="NavBtn === 'home'" style="color:rgb(46,148,250)">
          <div class="el-icon-house"></div>
          <div style="font-size:0.5rem">主页</div>
        </div>
        <div v-if="NavBtn !== 'home'">
          <div class="el-icon-house"></div>
          <div style="font-size:0.5rem">主页</div>
        </div>
        <!-- <img :src="NavBtn === 'home'? require('../img/22.png') : require('../img/21.png')"> -->
      </div>
      <div class="Navigation_btn" @click="navBtn('comment')">
        <div v-if="NavBtn === 'comment'" style="color:rgb(46,148,250)">
          <div class="el-icon-edit-outline"></div>
          <div style="font-size:0.5rem">考试</div>
        </div>
        <div v-if="NavBtn !== 'comment'">
          <div class="el-icon-edit-outline"></div>
          <div style="font-size:0.5rem">考试</div>
        </div>
        <!-- <img :src="NavBtn === 'comment'? require('../img/24.png') : require('../img/23.png')"> -->
      </div>
      <div class="Navigation_btn" @click="navBtn('custom')">
        <div v-if="NavBtn === 'custom'" style="color:rgb(46,148,250)">
          <div class="el-icon-user"></div>
          <div style="font-size:0.5rem">个人中心</div>
        </div>
        <div v-if="NavBtn !== 'custom'">
          <div class="el-icon-user"></div>
          <div style="font-size:0.5rem">个人中心</div>
        </div>
        <!-- <img :src="NavBtn === 'custom'? require('../img/26.png') : require('../img/25.png')"> -->
      </div>
    </div>
  </div>
</template>

<script>
import home from './home'
import comment from './comment'
import custom from './custom'

export default {
  data () {
    return {
      NavBtn: 'home',
      i: 0
    }
  },
  components: {
    home,
    comment,
    custom
  },
  mounted () {
    this.$refs.mychild.getToken()
  },
  methods: {
    // 导航
    navBtn (data) {
      this.NavBtn = data
      this.$refs.mychild.getLearnList()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$refs.mychild.getToken()
    })
  },
  // 路由跳出后
  beforeRouteLeave (to, from, next) {
    next()
  }
}
</script>

<style scoped>
.Navigation{
  bottom: 0;
  position: fixed;
  left: 0;
  width: 100%;
  display: flex;
}
.Navigation_btn{
  display: flex;
  font-size: 2rem;
  background-color: rgb(204, 204, 204);
  height: 3rem;
  padding: 1rem;
  width: 33.33%;
  text-align: center;
  flex-direction: column-reverse;
}
.color{
  color: rgb(8, 150, 245);
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue